import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  QualificationWave,
  listWaves,
} from '@/services/workflow/qualification';

export const QUALIFICATION_WAVES_QUERY_KEY = 'qualification-waves';

export const useQualificationWaves = (
  client: string | undefined,
  region: string | undefined,
  options?: Partial<UseQueryOptions<QualificationWave[], Error>>,
) =>
  useQuery<QualificationWave[], Error>({
    queryKey: [QUALIFICATION_WAVES_QUERY_KEY, client, region],
    queryFn: async ({ signal }) => {
      if (!client || !region) throw new Error('No client or region');
      return listWaves(client, region, signal);
    },
    enabled: !!client && !!region,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
